module.exports = __webpack_public_path__ + "img/PostgreSQL.50156c71.png";